// tslint:disable-next-line:typedef
export const ENV = {
	mode: 'HML',
	api: 'https://homologapi.fastget.com.br',
	proxy: '/proxy/webservice/hml',
	consumerWebApp: 'https://homologshop.fastget.com.br',
	googleKey: 'AIzaSyA1kO2xZX-4k5OgV1HusULfyGzv0KJzuGw',
	recaptchaKey: '6LfzNtgcAAAAALAPtvPpd7KHbB_Dl75PxoPVGO9k',
	push: {
		nativeAppId: "dad520cf-c3ca-4a51-b758-3fbfac01d049",
		webAppId: "e31d551a-ef0d-4abd-91fe-b1d3d661b508",
		google_project_number: "49745674411"
	},
	festivalBomGormet: {
		uuid: "c2e7e4b1-b050-45d2-b9a5-d0107e3938a1"
	},
	gaId: "UA-139888130-4",
	registerFinishedConversionTag: "-"
};



// WEBPACK FOOTER //
// ./src/env/env.ts